import dayjs from "dayjs";

import { shortMonthAndFullYear } from "@similarweb/pro-logic-components";

import { CHART_COLORS } from "app/constants/ChartColors";
import { SERP_FEATURES_MAP } from "app/common/serp/SerpFilterMaps";
import { SERP_MAP } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";

import type { ISerpDistributionItem } from "./types";

const DEFAULT_SELECTED_ITEMS = 5;

export interface ITransformedSerpItem {
    id: string;
    name: string;
    color: string;
    visible: boolean;
    data: Array<[number, number]>;
}

export const transformSerpFeaturesDistribution = (
    serpData: ISerpDistributionItem[],
    acquireColor: () => string,
): ITransformedSerpItem[] => {
    if (!serpData.length) {
        return [];
    }

    const featureGroups: Record<string, Map<string, number>> = {};

    serpData.forEach((monthData) => {
        Object.entries(monthData.serpFeatures).forEach(([featureKey, value]) => {
            if (!SERP_FEATURES_MAP[featureKey] && !SERP_MAP[featureKey]) {
                return;
            }

            if (!featureGroups[featureKey]) {
                featureGroups[featureKey] = new Map();
            }

            featureGroups[featureKey].set(monthData.yearmonth, value);
        });
    });

    // convert the grouped data to the required format
    const transformedData: ITransformedSerpItem[] = [];

    Object.entries(featureGroups).forEach(([featureKey, monthValues], idx) => {
        const seriesData: Array<[number, number]> = [];

        // convert the Map to sorted array of [timestamp, value] pairs
        Array.from(monthValues.entries())
            .sort(([monthA], [monthB]) => monthA.localeCompare(monthB))
            .forEach(([month, value]) => {
                const timestamp = dayjs.utc(month, shortMonthAndFullYear).valueOf();
                seriesData.push([timestamp, value]);
            });

        const isVisible = idx < DEFAULT_SELECTED_ITEMS;

        transformedData.push({
            id: featureKey,
            name: SERP_FEATURES_MAP[featureKey]?.name || SERP_MAP[featureKey]?.name || featureKey,
            color: isVisible ? acquireColor() : CHART_COLORS.fallbackColor,
            visible: isVisible,
            data: seriesData,
        });
    });

    return transformedData;
};
